module.exports = __webpack_public_path__ + "static/img/jpg.4f3ad5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BTOC/jpg.png
// module id = h5gP
// module chunks = 1